import React, { useEffect, useState } from 'react'
import { Badge, Chip, IconButton, MenuItem, Popover, TableCell, Tooltip, Typography } from '@mui/material'
import { GrcTable, GrcTableBody, GrcTableCell, GrcTableContainer, GrcTableHead, GrcTableHeadRow, GrcTableRow } from '../../../Common/ui/TableComponent'
import CustomSearchField from '../../../Common/ui/searchInput'
import PropTypes from 'prop-types'
import EditPencilIcon from '../../../Common/Icon/EditPencilIcon'
// import { RiVideoAddLine } from 'react-icons/ri'
// import { AiOutlineApartment } from 'react-icons/ai'
import { Button } from 'src/Common/ui/button'
import { FaRectangleList } from 'react-icons/fa6'
import { Checkbox } from 'src/Common/ui/checkbox'
import { useLocation, useNavigate, useParams } from 'react-router'
import { cn, featValid, roleColor } from 'src/lib/utils'
import AddSquareIcon from 'src/Common/Icon/AddSquareIcon'
import PopoverMui from 'src/Common/ui/PopoverMui'
import { useTranslation } from 'react-i18next'
import { catgoryFunnelBox, frequencyFunnelBox } from 'src/Entities/ComplianceListViewEntity'
import { COLUMN_FREQ_TOTAL_IND, GOVERNANCE_PARAM, INFORMED_INDEX_RACI, lawTypes, REGULATION_PARAM } from 'src/Entities/Governance'
import { CREATE_GOVERNANCE_SETUP, UPDATE_GOVERNANCE_SETUP, VIEW_GOVERNANCE_SETUP } from 'src/Entities/Features'
import { ACC_RACID, OPTION_ACCOUNTABLE, OPTION_CONSULTED, OPTION_FREQUENCY, OPTION_INFORMED, OPTION_RESPONSIBLE, OPTION_TOTAL } from 'src/Entities/ComplianceTypes'
import { AiOutlineCluster } from 'react-icons/ai'
import * as RoutePaths from '../../../Entities/RoutePath'
import { toast } from 'react-toastify'
import { MENU_TYPE_COMPLIANCE_SETUP, MENU_TYPE_GOVERNANCE_SETUP } from 'src/Entities/MainContainerTypes'
import { FREQUENCY_PARAM, STATUS_PARAM } from 'src/Entities/CommonEntities'
import { FILTER_RESET, FILTER_SHOW_HIDE } from 'src/Entities/RiskTypes'
import { setIsSelectCompliance } from '../Store/ComplianceStore'

function RegulatoryTable ({
    setTotalPages, type = MENU_TYPE_GOVERNANCE_SETUP, onboard, routePath, regulation, setEntries, regulationTableData, handleEditClick, setIsSelectRegulation, currentPage
}) {
    const [ regulationTableSearchValue, setregulationTableSearchValue ] = useState('')
    const rowsPerPage = 5
    const [ filteredRegulationData, setfilteredRegulationData ] = useState()
    const [ paginatedData, setPaginatedData ] = useState([])
    const { t } = useTranslation()
    const location = useLocation()
    const { mandateType, regulationName } = useParams()
    const queryParams = new URLSearchParams(location.search)
    const bodyType = queryParams.get('bodyType')
    const regulationId = queryParams.get('regulationId')
    useEffect(() => {
        setregulationTableSearchValue('')
    }, [location])
    useEffect(() => {
        setfilteredRegulationData(regulationTableData)
        if (regulation) {
            setTypeFilter([ ...frequencyFunnelBox, { label: FILTER_SHOW_HIDE, value: FILTER_SHOW_HIDE, checked: true, show: true }])
        } else {
            setTypeFilter([ ...catgoryFunnelBox, { label: FILTER_SHOW_HIDE, value: FILTER_SHOW_HIDE, checked: true, show: true }])
        }
    }, [regulationTableData])
    useEffect(() => {
        setTotalPages(Math.ceil(filteredRegulationData?.length / rowsPerPage))
    }, [filteredRegulationData])
    const [ anchorEl, setAnchorEl ] = React.useState(null)
    const [ options, setOptions ] = useState([
        { value: regulation !== 0 ? 'Compliance Title' : 'Body', isChecked: true, display: false, disable: true },
        { value: regulation !== 0 ? 'Frequency' : 'Total', isChecked: true, display: false, disable: true },
        { value: 'Category', isChecked: true, display: false, disable: true },
        { value: 'Department', isChecked: true, display: false, disable: true },
        { value: t('Responsible'), isChecked: true, display: false, disable: true },
        { value: t('Accountable'), isChecked: true, display: false, disable: true },
        { value: t('Consulted'), isChecked: true, display: false, disable: true },
        { value: t('Informed'), isChecked: true, display: false, disable: true }
    ])
    useEffect(() => {
        if (anchorEl) {
            setOptions(options.map((ele, i) => {
                if (i === COLUMN_FREQ_TOTAL_IND) {
                    ele.value = regulation !== GOVERNANCE_PARAM ? OPTION_FREQUENCY : OPTION_TOTAL
                }
                if (ele.value === OPTION_CONSULTED || ele.value === OPTION_INFORMED) ele.disable = false
                if (regulation !== GOVERNANCE_PARAM && ele.value === OPTION_ACCOUNTABLE) {
                    ele.disable = false
                } else if (regulation === GOVERNANCE_PARAM && ele.value === OPTION_ACCOUNTABLE) {
                    ele.disable = true
                }
                return ele
            }))
        }
    }, [anchorEl])
    const [ selectAll, setSelectAll ] = useState(true)
    // const [ meetingList, setMeetingList ] = useState([])
    // const [ selectAllList, setSelectAllList ] = useState(false)
    const [ typeFilter, setTypeFilter ] = useState([])
    const [ showTypeFilter, setShowTypeFilter ] = useState(false)
    const handleSelectAll = (event) => {
        setOptions(options.map((ele) => {
            if (selectAll && !ele.disable) {
                ele.isChecked = false
            } else {
                ele.isChecked = true
            }
            return ele
        }))
        setSelectAll(!selectAll)
    }
    const features = JSON.parse(localStorage.getItem('features'))
    const handleTypeFilter = (event, item) => {
        setTypeFilter(typeFilter.map((ele) => {
            if (item === FILTER_RESET) {
                ele.checked = true
            }
            if (item === FILTER_SHOW_HIDE) {
                ele.checked = event
            } else if (ele.value === item) {
                ele.checked = !ele.checked
            }
            return ele
        }))
    }
    const handleTypeClick = (event) => {
        setShowTypeFilter(event.target)
    }

    const [ searchQuery, setSearchQuery ] = useState('')

    const handleSearchChange = (event) => {
        setSearchQuery(event)
    }

    const columnSelectChange = (event, item) => {
        setOptions(options.map((ele) => {
            if (item === FILTER_RESET) {
                ele.isChecked = true
                setSelectAll(true)
            }
            if (ele.value === item) {
                ele.isChecked = !ele.isChecked
            }
            return ele
        }))
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const navigate = useNavigate()
    const handleOpenRegulations = (item) => {
        if (!onboard) {
            if (regulation) {
                if (featValid(features, VIEW_GOVERNANCE_SETUP)) {
                    navigate(routePath + '/' + mandateType + '/' + regulationName + '/' + item.title + '?bodyType=' + bodyType + '&regulation=' + REGULATION_PARAM + '&regulationId=' + regulationId + '&complianceId=' + item.id)
                }
            } else {
                if (item?.raciiMatrices?.find((ele) => ele.raciId === ACC_RACID)) {
                    if (type === MENU_TYPE_COMPLIANCE_SETUP) navigate(routePath + '/' + lawTypes?.find((findDt) => String(item.typeId) === findDt?.value)?.label + '/' + item.regulation + '?bodyType=' + bodyType + '&regulation=' + REGULATION_PARAM + '&status=' + STATUS_PARAM + '&frequency=' + FREQUENCY_PARAM + '&regulationId=' + item.regulationId)
                } else {
                    toast.warning(<p>RACI selection is required.</p>, { position: 'top-right', theme: 'light' })
                }
            }
        }
    }
    const handleAddComplaince = () => {
        navigate(routePath + '/' + mandateType + '/' + regulationName + '/Add compliance' + '?bodyType=' + bodyType + '&regulation=' + 1 + '&regulationId=' + regulationId + '&complianceId=create')
    }

    useEffect(() => {
        setPaginatedData(filteredRegulationData?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
    }, [ filteredRegulationData, currentPage ])
    useEffect(() => {
        setOptions(options.map(item => {
            if (!item.value.toLowerCase().includes(searchQuery.toLowerCase())) {
                item.display = false
            } else {
                item.display = true
            }
            return item
        }))
    }, [searchQuery])
    useEffect(() => {
        if (filteredRegulationData?.length > 0) {
            let data = []
            if (regulation) {
                const finalData = filteredRegulationData.map((item) => {
                    if (typeFilter.find(ele => ele.value === item.frequency && ele.checked)) {
                        return item
                    }
                    return null
                }).filter(ele => ele !== null)
                data = finalData
            } else {
                const finalData = filteredRegulationData.map((item) => {
                    if (typeFilter.find(ele => ele.value === item.regulationCategory && ele.checked)) {
                        return item
                    }
                    return null
                }).filter(ele => ele !== null)
                data = finalData
            }
            setPaginatedData(data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
        }
    }, [ filteredRegulationData, typeFilter ])
    useEffect(() => {
        setfilteredRegulationData(
            regulationTableData?.filter((row) =>
                Object.values(row).some(
                    (value) =>
                        value !== null &&
                        value !== undefined &&
                        value.toString().toLowerCase().includes(regulationTableSearchValue?.toLowerCase())
                )
            )
        )
    }, [ regulationTableSearchValue, regulationTableData ])
    const [ sortToggle, setSortToggle ] = useState(false)
    const totalSort = (findOf) => {
        const sorted = filteredRegulationData.sort((a, b) => {
            if (!sortToggle) {
                if (a[findOf] < b[findOf]) {
                    return -1
                }
                if (a[findOf] > b[findOf]) {
                    return 1
                }
                return 0
            } else {
                if (b[findOf] < a[findOf]) {
                    return -1
                }
                if (b[findOf] > a[findOf]) {
                    return 1
                }
                return 0
            }
        })
        setSortToggle(!sortToggle)
        setPaginatedData(sorted?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
        setfilteredRegulationData(sorted)
    }

    const sortFilter = (findOf) => {
        const sorted = filteredRegulationData.sort((a, b) => {
            if (typeof a[findOf] === typeof 'string') {
                if (sortToggle) {
                    return a[findOf].toLowerCase().localeCompare(b[findOf].toLowerCase())
                } else {
                    return b[findOf].toLowerCase().localeCompare(a[findOf].toLowerCase())
                }
            } else {
                if (sortToggle) {
                    return a[findOf] - b[findOf]
                } else {
                    return b[findOf] - a[findOf]
                }
            }
        })
        setSortToggle(!sortToggle)
        setPaginatedData(sorted?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
        setfilteredRegulationData(sorted)
    }
    const sortFilterRaci = (findOf) => {
        const sorted = filteredRegulationData?.sort((a, b) => {
            const userA = a.raciiMatrices?.find(ele => ele.raciId === findOf)?.user?.toLowerCase() || ''
            const userB = b.raciiMatrices?.find(ele => ele.raciId === findOf)?.user?.toLowerCase() || ''

            return sortToggle
                ? userA.localeCompare(userB)
                : userB.localeCompare(userA)
        })
        setSortToggle(!sortToggle)
        setPaginatedData(sorted?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
        setfilteredRegulationData(sorted)
    }
    const handleChange = (value) => {
        queryParams.set('bodyType', value)
        navigate(`?${queryParams.toString()}`)
    }

    useEffect(() => {
        setEntries({
            entry: filteredRegulationData?.length,
            from: (currentPage - 1) * rowsPerPage + 1,
            to: (currentPage - 1) * rowsPerPage + paginatedData?.length - 1 + 1
        })
    }, [paginatedData])
    const [ showDepartments, setShowDepartments ] = useState(null)
    const [ departments, setDepartments ] = useState([])
    const handleClose = () => {
        setShowDepartments(null)
    }
    const handleOpenDepartments = (event, impactedDepartment) => {
        setShowDepartments(event.currentTarget)
        setDepartments(impactedDepartment)
    }

    const [ departmentSortAsc, setDepartmentSortAsc ] = useState(true)
    const handleSortDepartments = () => {
        const sorted = [...filteredRegulationData].sort((a, b) => {
            const depA = a.departments?.length ? a.departments?.[0]?.toLowerCase() : ''
            const depB = b.departments?.length ? b.departments?.[0]?.toLowerCase() : ''

            // If one of them has no department, push it to the end
            if (!depA && depB) return 1
            if (depA && !depB) return -1

            // Sort normally A-Z or Z-A
            return departmentSortAsc ? depA.localeCompare(depB) : depB.localeCompare(depA)
        })

        setDepartmentSortAsc(!departmentSortAsc)
        setfilteredRegulationData(sorted)
    }
    const [ typeFilterSearch, setTypeFilterSearch ] = useState('')
    const handleTypeFilterSearch = (e) => {
        setTypeFilterSearch(e)
    }
    // const tableHeaders = [
    //     { field: '#', headerName: '#', checked: true, className: '', style: {}, filter: '' },
    //     { field: 'Compliance Title', headerName: 'Risk', checked: true, className: '', style: {}, filter: '' },
    //     { field: 'Frequency', headerName: 'Frequency', checked: true, className: '', style: {}, filter: '' },
    //     { field: 'category', headerName: 'Category', checked: true, className: '', style: {}, filter: '' },
    //     { field: 'Category', headerName: 'Department', checked: true, className: '', style: {}, filter: '' },
    //     { field: 'role', headerName: 'Responsible', checked: true, className: '', style: {}, filter: '' },
    //     { field: 'role', headerName: 'Accountable', checked: true, className: '', style: {}, filter: '' },
    //     { field: 'role', headerName: 'Consulted', checked: true, className: '', style: {}, filter: '' },
    //     { field: 'role', headerName: 'Informed', checked: true, className: '', style: {}, filter: '' },
    // ]
    const data = typeFilter.filter(ele => ele.label === FILTER_SHOW_HIDE || ele.label.toLowerCase().includes(typeFilterSearch))

    return (
        <div className='h-[90%]'>
            <Popover
                open={Boolean(showDepartments)}
                anchorEl={showDepartments}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                {
                    departments?.map((item, i) => {
                        return (
                            <div key={i}>

                                {i !== 0 && <div key={i} className='p-4 flex items-center' >
                                    <div>{item}</div>
                                </div>}
                            </div>
                        )
                    })
                }

            </Popover>
            <div className='flex justify-between p-4'>
                <div className='flex gap-2'>
                    {(onboard) && <div style={{ display: 'flex', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '100px', height: '40px', width: 'fit-content', padding: '0', overflow: 'hidden' }}>
                        {lawTypes.map((item) => {
                            return (
                                <>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 10px',
                                            margin: '5px',
                                            borderRadius: '100px',
                                            cursor: 'pointer',
                                            backgroundColor: bodyType + '' === item.value + '' ? 'hsl(var(--primary))' : '',
                                            color: bodyType + '' === item.value + '' ? 'hsl(var(--card))' : 'hsl(var(--muted))',
                                            transition: 'background-color 0.3s, color 0.3s',
                                            whiteSpace: 'nowrap',
                                            fontSize: '14px'
                                        }}
                                        onClick={() => handleChange(item.value)} >{item.label}</div>
                                </>
                            )
                        })}
                    </div>}
                    <CustomSearchField className={'h-[43px]'} value={regulationTableSearchValue} setSearch={setregulationTableSearchValue} onValueChange={(e) => setregulationTableSearchValue(e)} />
                </div>
                <div className="ml-auto space-x-5 mr-4  flex items-center">
                    {!regulation && !onboard && <>
                        {/* <div className={cn(meetingList.length > 0 ? '' : 'pointer-events-none')}>
                            <Button variant="outline" className={cn(meetingList.length > 0 ? '' : 'pointer-events-none', 'grc-btn-one')}>
                                <RiVideoAddLine size={24} />
                            </Button>
                        </div> */}
                        {/* <Button variant="outline" className="grc-btn-one">
                            <AiOutlineApartment size={24} />
                        </Button> */}
                        <Tooltip title="View Org Chart" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <Button variant="outline" className="grc-btn-one flex items-center justify-center p-2" onClick={() => navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.GOVERNANCE.ORG_CHART)}>
                                {/* <img src={'/Common/Icon/NetworkTree.svg'} className="w-6 h-6" /> */}
                                <AiOutlineCluster size={24} />
                            </Button>
                        </Tooltip>
                    </>}
                    {regulation
                        ? <>
                            <Tooltip title="Download" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <Button variant="outline" className="grc-btn-one mr-2 !p-[6px]"><img className='w-[20px]' src='/Common/Icon/downloadIcon.svg' /></Button>
                            </Tooltip>
                            { featValid(features, CREATE_GOVERNANCE_SETUP) &&
                            <Tooltip title="Add Compliance" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <Button onClick={() => handleAddComplaince()} variant="outline" className="grc-btn-one">
                                    <img src='/Common/Icon/addIcon.svg' />
                                </Button></Tooltip>}
                        </>
                        : null
                    }
                    <Tooltip title="Column Setting" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <Button aria-describedby={1} className="grc-btn-one mr-2 !p-[6px]" variant="outline" onClick={handleClick}>
                            <img src={'/Common/Icon/columnFilter.svg'} onClick={handleClick} alt="ColumFilter.svg" />
                        </Button>
                    </Tooltip>
                    <PopoverMui id={2} anchorEl={anchorEl} setAnchorEl={setAnchorEl} handleClick={handleClick}>
                        <CustomSearchField className={'h-[43px] w-full p-1'} value={searchQuery} setSearch={setSearchQuery} onValueChange={(e) => handleSearchChange(e)} />
                        {
                            options?.filter((filterDt) => (!onboard || (onboard && filterDt?.value !== 'Frequency')))?.map((item, i) => {
                                if (item.value === OPTION_RESPONSIBLE && !regulation) return null
                                return (
                                    <>
                                        {item.display &&
                                        <MenuItem sx={{ padding: 0 }} disabled={item.disable} key={item.value}>
                                            <div key={i} className='flex items-center gap-4 px-4 py-2'>
                                                <Checkbox
                                                    checked={item.isChecked}
                                                    onCheckedChange={(event) => columnSelectChange(event, item.value)}
                                                    className="mr-2"
                                                    borderColor='text-primary'
                                                    id={i}
                                                />
                                                <label htmlFor={i} key={i}>{item.value}</label>
                                            </div></MenuItem>}
                                    </>
                                )
                            })
                        }
                        {
                            options.find(ele => ele.display === true) ? '' : <div className='p-4 flex justify-center'><div className='align-center'>No options found</div></div>
                        }
                        { <div className='flex items-center gap-4 px-4 py-2'>
                            <Checkbox
                                checked={selectAll}
                                onCheckedChange={(event) => handleSelectAll(event)}
                                className="mr-2"
                                borderColor='text-primary'
                            />
                            <div className='flex justify-between w-full items-center'><div>{FILTER_SHOW_HIDE}</div>
                                {<span className={cn(options.some(el => !el.isChecked) ? '' : 'pointer-events-none !text-grey', 'align-right text-sm ml-10 underline text-primary cursor-pointer')} onClick={() => columnSelectChange('', FILTER_RESET)}>Reset</span>}</div>
                        </div>}
                    </PopoverMui>
                    {!regulation && featValid(features, CREATE_GOVERNANCE_SETUP) && type === MENU_TYPE_GOVERNANCE_SETUP ? <Button onClick={() => setIsSelectRegulation(true)} variant='outline' className='ml-auto h-[80%]'><FaRectangleList size={24} /><span className='pl-2'>Select Regulation</span></Button> : null}
                    {regulation && featValid(features, CREATE_GOVERNANCE_SETUP) ? <Button onClick={() => setIsSelectCompliance(true)} variant='outline' className='ml-auto h-[80%]'><FaRectangleList size={24} /><span className='pl-2'>Select Compliance</span></Button> : null}

                </div>
            </div>
            <div className='h-[85%]'>
                <div className='p-4 h-full'>
                    <PopoverMui id={2} anchorEl={showTypeFilter} setAnchorEl={setShowTypeFilter}>
                        <CustomSearchField className={'w-[100%] p-1'} value={typeFilterSearch} setSearch={setTypeFilterSearch} onValueChange={handleTypeFilterSearch} />
                        {
                            data.length === 1
                                ? <div className="flex justify-center h-full items-center p-4">
                                    <div className="text-sm text-muted ">No Data</div>
                                </div>
                                : null
                        }
                        {
                            data?.map((item, i) => {
                                return (
                                    <div key={i} className='p-4 flex items-center' >
                                        <Checkbox
                                            checked={item.checked}
                                            onCheckedChange={(event) => handleTypeFilter(event, item.value)}
                                            className="mr-2"
                                            borderColor='text-primary'
                                            id={`${item.label}-${i}`}
                                        />
                                        <label htmlFor={`${item.label}-${i}`} className="cursor-pointer text-submenu !font-regular">{item?.label}</label>
                                        {i === typeFilter?.length - 1 && <span className={cn(typeFilter.some(el => !el.checked) ? '' : 'pointer-events-none !text-grey', 'align-right text-sm ml-10 underline text-primary cursor-pointer')} onClick={() => handleTypeFilter('', FILTER_RESET)}>Reset</span>}

                                    </div>
                                )
                            })
                        }
                    </PopoverMui>
                    <div className='h-full overflow-auto'>
                        <GrcTableContainer>
                            <GrcTable>
                                <GrcTableHead>
                                    <GrcTableHeadRow>
                                        <GrcTableCell className="col-sticky" sx={{ minWidth: '100px', left: 0, zIndex: 1 }}>
                                            <div className='flex justify-between'>
                                                <Tooltip title="S.No" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                    <div className='mr-1'>#</div></Tooltip>
                                            </div>
                                        </GrcTableCell>
                                        {options[0].isChecked && <GrcTableCell className="col-sticky" sx={{ minWidth: '24rem', left: 40, zIndex: 1 }}>{regulation ? 'Compliance Title' : 'Regulation'}
                                            <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                <img onClick={() => sortFilter(regulation ? 'title' : 'regulation')} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' />
                                            </Tooltip>
                                        </GrcTableCell>}
                                        {options[1].isChecked && !onboard &&
                                        <GrcTableCell className="col-sticky !flex justify-center" align='center' sx={{ minWidth: '100px', left: 264, zIndex: 1 }}>{regulation ? 'Frequency' : 'Total'}
                                            {regulation
                                                ? <Tooltip title="Filter" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><img onClick={handleTypeClick} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/FunnelFilter.svg' /></Tooltip>
                                                : <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><img onClick={() => totalSort('total')} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip>
                                            }
                                        </GrcTableCell>}

                                        {options[2].isChecked && !regulation && <GrcTableCell align='center' sx={{ minWidth: '180px' }}>{ 'Category'}<Tooltip title="Filter" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><img onClick={handleTypeClick} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/FunnelFilter.svg' /></Tooltip>
                                        </GrcTableCell>}
                                        {options[3].isChecked && <GrcTableCell align='center' sx={{ minWidth: '180px' }}>{t('Department')}<Tooltip title='Sort' placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><img onClick={() => handleSortDepartments()} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip></GrcTableCell>}

                                        {options[4].isChecked && regulation ? <GrcTableCell align='center' sx={{ minWidth: '180px' }}>{t('Responsible')}<Tooltip title='Sort' placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><img onClick={() => sortFilterRaci(1)} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip></GrcTableCell> : null}
                                        {options[5].isChecked && <GrcTableCell align='center' sx={{ minWidth: '180px' }}>{t('Accountable')}<Tooltip title='Sort' placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><img onClick={() => sortFilterRaci(2)} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip></GrcTableCell>}
                                        {options[6].isChecked && <GrcTableCell align='center' sx={{ minWidth: '180px' }}>{t('Consulted')}<Tooltip title='Sort' placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><img onClick={() => sortFilterRaci(3)} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip></GrcTableCell>}
                                        {options[7].isChecked && <GrcTableCell align='center' sx={{ minWidth: '180px' }}>{t('Informed')}<Tooltip title='Sort' placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><img onClick={() => sortFilterRaci(4)} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip></GrcTableCell>}
                                        {type === MENU_TYPE_GOVERNANCE_SETUP && <GrcTableCell className="col-sticky" sx={{ minWidth: '40px', right: 0 }} />}
                                    </GrcTableHeadRow>
                                </GrcTableHead>
                                <GrcTableBody>
                                    {paginatedData?.length > 0
                                        ? (paginatedData?.map((item, indexx) => {
                                            return <GrcTableRow key={indexx}>
                                                <GrcTableCell className="col-sticky-td" sx={{ minWidth: '40px', left: 0, zIndex: 1 }}>
                                                    <div className='flex justify-between items-center'>
                                                        <div className='h-6 text-center min-w-6 flex justify-center items-center rounded-full bg-[hsl(var(--primary-thick-foreground))]'>
                                                            <div className='text-primary'>{(currentPage - 1) * rowsPerPage + indexx + 1}</div>
                                                        </div>
                                                    </div>
                                                </GrcTableCell>
                                                {options[0].isChecked && <GrcTableCell className="col-sticky-td  cursor-pointer" onClick={() => handleOpenRegulations(item)} sx={{ minWidth: '24rem', left: 40, zIndex: 1 }}>{!regulation
                                                    ? item?.regulation
                                                    : <div>
                                                        <div>{item?.title}</div>
                                                        <div className="flex flex-row text-[12px] gap-1 justify-row items-center">
                                                            <Tooltip title={`#${item?.referenceId || 0}`} arrow placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }} style={{ width: 'fit-content !important' }}>
                                                                <Chip className="whitespace-nowrap" label={`#${item?.referenceId || 0}`} sx={{ backgroundColor: 'hsl(var(--primary))', fontSize: '12px', color: '#fff', width: '40%', height: '17px', overflow: 'hidden', textOverflow: 'ellipsis', margin: '4px' }} />
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                }</GrcTableCell>}
                                                {options[0].isChecked && !onboard && <GrcTableCell align='center' className='sticky-border col-sticky-td' sx={{ minWidth: '50px', left: 264, zIndex: 1 }}>{<div className='border-none min-w-[150px]'>{!regulation ? item?.total : item.frequency}</div>}</GrcTableCell>}

                                                {options[1].isChecked && !regulation && <GrcTableCell align='center' sx={{ minWidth: '180px' }}>{item.regulationCategory}</GrcTableCell>}
                                                {options[2].isChecked
                                                    ? <GrcTableCell align='center' sx={{ minWidth: '180px' }}>{
                                                        item?.departments?.length > 0
                                                            ? <Tooltip title="Click to View" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }} disableHoverListener={regulation ? true : item?.departments?.length === 1}>
                                                                <div className='flex items-center justify-center'>
                                                                    <Typography>{regulation ? item?.departments : item?.departments[0]}</Typography>
                                                                    {!regulation && <Badge className='cursor-pointer z-0' onClick={(event) => handleOpenDepartments(event, item?.departments)} badgeContent={`+${item?.departments?.length - 1}`} sx={{ '& .MuiBadge-badge': { backgroundColor: 'hsl(var(--primary-foreground))', color: 'hsl(var(--primary))', fontSize: '0.9rem', fontWeight: '500', top: '-6px', right: '-5px' }, display: item?.departments?.length === 1 && 'none', ml: 1.5, mt: 1, zIndex: 0 }}>
                                                                    </Badge>}
                                                                </div>
                                                            </Tooltip>
                                                            : <div>-</div>}</GrcTableCell>
                                                    : null}

                                                {
                                                    Array.from({ length: 4 }, () => null).map((ele, j) => {
                                                        const data = item?.raciiMatrices?.find((element) => {
                                                            return +element.raciId === j + 1
                                                        })
                                                        if (j === 0 && !regulation) return null
                                                        return (
                                                            <>
                                                                {
                                                                    options[j + 3]?.isChecked && (data
                                                                        ? <GrcTableCell align='center' sx={{ minWidth: '180px' }}>
                                                                            <div>
                                                                                {!data.user && data.department && data.role && j !== 3
                                                                                    ? <div className='flex justify-center gap-1'><img src='/Common/Icon/DangerIcon.svg' />Vacant</div>
                                                                                    : !data.user
                                                                                        ? (
                                                                                            <div className='text-muted'>-</div>
                                                                                        )
                                                                                        : null}
                                                                                <p className='regulation-cell-first !text-[16px] whitespace-nowrap'>{data?.user}</p>
                                                                                { !data.user && j === INFORMED_INDEX_RACI ? null : <p style={{ color: roleColor(data?.role) }} className={cn('regulation-cell-third', '!text-[12px] mt-1 whitespace-nowrap')}>{data?.role}</p> }
                                                                            </div>
                                                                        </GrcTableCell>
                                                                        : <GrcTableCell align='center'>-</GrcTableCell>)
                                                                }
                                                            </>
                                                        )
                                                    })
                                                }

                                                {(!onboard && type === MENU_TYPE_GOVERNANCE_SETUP) && featValid(features, UPDATE_GOVERNANCE_SETUP) &&
                                                    <GrcTableCell className='col-sticky-td' sx={{ minWidth: '40px', right: 0 }}> <Tooltip title="Edit RACI" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                        <IconButton onClick={() => handleEditClick(item)} ><EditPencilIcon /></IconButton>
                                                    </Tooltip></GrcTableCell>}
                                                {onboard && featValid(features, CREATE_GOVERNANCE_SETUP) &&
                                                     <GrcTableCell className='col-sticky-td' sx={{ minWidth: '40px', right: 0 }}><Tooltip title="Add RACI" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                         <IconButton onClick={() => handleEditClick(item)} ><AddSquareIcon/></IconButton>
                                                     </Tooltip></GrcTableCell>}

                                            </GrcTableRow>
                                        }

                                        ))
                                        : (<GrcTableRow>
                                            <TableCell colSpan={8} align='center'>{t('No Records Found')}</TableCell>
                                        </GrcTableRow>)
                                    }
                                </GrcTableBody>

                            </GrcTable>
                        </GrcTableContainer>
                    </div>

                </div>
            </div>

        </div>
    )
}

RegulatoryTable.propTypes = {
    regulationTableData: PropTypes.any,
    headers: PropTypes.any,
    handleEditClick: PropTypes.func,
    onboard: PropTypes.any,
    checkbox: PropTypes.any,
    routePath: PropTypes.any,
    regulation: PropTypes.any,
    setIsSelectRegulation: PropTypes.any,
    currentPage: PropTypes.any,
    setCurrentPage: PropTypes.any
}

export default RegulatoryTable
